<template>
  <span>
    <!-- eslint-disable-next-line vue/no-v-html -- safe: localized translation string sanitized via cleanedValue -->
    <span v-if="tKey" v-html="tValue"></span>
    <!-- eslint-disable-next-line vue/no-v-html -- safe: input is sanitized in cleanedValue -->
    <span v-else v-html="cleanedValue"></span>
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

interface Props {
  value?: string;
}

const props = withDefaults(defineProps<Props>(), { value: "" });

const { t } = useI18n();

const cleanedValue = computed(() => {
  if (props.value) {
    return props.value.replace(/<(?!wbr\s*\/?)[^>]+>/gm, ""); //https://regex101.com/r/sROTjR/1  Remove all tags except word-break
  }
  return null;
});

const tKey = computed(() => {
  if (
    cleanedValue.value &&
    cleanedValue.value.length > 2 &&
    cleanedValue.value.startsWith("{") &&
    cleanedValue.value.endsWith("}")
  ) {
    return cleanedValue.value.substring(1, cleanedValue.value.length - 1);
  } else {
    return null;
  }
});

const tValue = computed(() => {
  return t(tKey.value).replace(/<(?!wbr\s*\/?)[^>]+>/gm, ""); //https://regex101.com/r/sROTjR/1  Remove all tags except word-break
});
</script>
